// Load CounterParty
export const START_LOAD_COUNTER_PARTY = 'START_LOAD_COUNTER_PARTY';
export const LOAD_COUNTER_PARTY_SUCCESS = 'LOAD_COUNTER_PARTY_SUCCESS';
export const LOAD_COUNTER_PARTY_FAILURE = 'LOAD_COUNTER_PARTY_FAILURE';
export const INIT_LOAD_COUNTER_PARTY_ACTION_STATUS = 'INIT_LOAD_COUNTER_PARTY_ACTION_STATUS';

